module.exports = __webpack_public_path__ + "expand-hover.7058e4.svg";